import React from "react";
import { Table, Row, Col, Typography, Divider } from "antd";
import OverallDistributionChart from "./overallDistributionChart";

const { Title, Text } = Typography;

const OverallSummary = ({
  student = {},
  summaryData = [],
  report_period = [],
  cumulative_grade,
  cumulative_grade_distribution = {},
  attendance = { absent_count: 0, late_count: 0, present_count: 0 },
}) => {
  const fullName = `${student?.first_name || ""} ${student?.last_name || ""}`;
  const login_id = student?.login_id || "";

  const normalizedDistribution = Object.entries(
    cumulative_grade_distribution
  ).reduce((acc, [grade, count]) => {
    const normalizedGrade = grade === "E" || grade === "U" ? "D" : grade;
    acc[normalizedGrade] = (acc[normalizedGrade] || 0) + count;
    return acc;
  }, {});

  const subjectSummaryData = summaryData.map((item, index) => {
    let grade = item.stream_runtime_grade ?? item.grade ?? "-";
    if (grade === "E" || grade === "U") grade = "D";

    return {
      key: String(index + 1),
      learning_activities: item.name || "",
      attendanceScale: attendance.attendance_scale || "-",
      competencyRate: `${(item.stream_runtime_competency_rate ??
        item.competency_rate ??
        0
      ).toFixed(2)}%`,
      status: item.progress_status || "",
      grade,
    };
  });

  const columns = [
    {
      title: "LEARNING ACTIVITY",
      dataIndex: "learning_activities",
      key: "learning_activities",
    },
    {
      title: "COMPETENCY RATE",
      dataIndex: "competencyRate",
      key: "competencyRate",
    },
    { title: "GRADE", dataIndex: "grade", key: "grade" },
  ];

  return (
    <div
      className="pdf-page"
      style={{
        width: "100%",
        maxWidth: "210mm",
        minHeight: "297mm",
        background: "white",
        margin: "20px auto",
        padding: "8mm",
        fontFamily: "Arial, sans-serif",
        color: "#333",
        boxSizing: "border-box",
        border: "1px solid #ccc",
        pageBreakInside: "avoid",
      }}
    >
      <div
        style={{
          marginBottom: "15px",
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          padding: "8px",
          background: "#f9f9f9",
          pageBreakInside: "avoid",
        }}
      >
        <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
          <Col>
            <Text strong style={{ fontSize: 16 }}>
              {report_period}
            </Text>
          </Col>
          <Col>
            <Text strong style={{ fontSize: 16 }}>
              {fullName}
            </Text>
          </Col>
          <Col>
            <Text strong>Login Id: {login_id}</Text>
          </Col>
        </Row>

        <Title level={2} style={{ color: "#50B6F2", marginTop: 0 }}>
          OVERALL SUMMARY
        </Title>

        <div
          style={{
            backgroundColor: "#50B6F2",
            color: "#fff",
            padding: "10px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            pageBreakInside: "avoid",
          }}
        >
          <div style={{ flex: 1, textAlign: "center" }}>GRADE</div>
          <div style={{ flex: 3, textAlign: "center" }}>DISTRIBUTION</div>
        </div>

        <Row align="middle" style={{ padding: "20px 0", overflow: "auto" }}>
          <Col span={4}>
            <Title level={1} style={{ color: "#50B6F2", textAlign: "center" }}>
              {cumulative_grade === "E" || cumulative_grade === "U"
                ? "D"
                : cumulative_grade || "-"}
            </Title>
          </Col>
          <Col span={20}>
            <div style={{ pageBreakInside: "avoid" }}>
              <h4
                style={{
                  marginBottom: "5px",
                  color: "#50B6F2",
                  fontWeight: "bold",
                }}
              >
                DISTRIBUTION
              </h4>
              <OverallDistributionChart
                chartData={normalizedDistribution}
                cumulative_grade={
                  cumulative_grade === "E" || cumulative_grade === "U"
                    ? "D"
                    : cumulative_grade
                }
              />
            </div>
          </Col>
        </Row>

        <Divider style={{ margin: "12px 0", pageBreakInside: "avoid" }} />
        <div
          style={{
            backgroundColor: "#50B6F2",
            color: "#fff",
            padding: "10px",
            fontWeight: "bold",
            pageBreakInside: "avoid",
          }}
        >
          ATTENDANCE
        </div>

        <Row style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
          <Col span={8}>
            <Text>Absent Days</Text>
            <br />
            <strong>{attendance.absent_count ?? 0}</strong>
          </Col>
          <Col span={8}>
            <Text>Late to School</Text>
            <br />
            <strong>{attendance.late_count ?? 0}</strong>
          </Col>
          <Col span={8}>
            <Text>Present Days</Text>
            <br />
            <strong>{attendance.present_count ?? 0}</strong>
          </Col>
        </Row>

        <div
          style={{
            backgroundColor: "#50B6F2",
            color: "#fff",
            padding: "10px",
            fontWeight: "bold",
            marginTop: 20,
            pageBreakInside: "avoid",
          }}
        >
          {report_period}
        </div>
        <div style={{ width: "100%", overflowX: "auto", pageBreakInside: "avoid" }}>
          <Table
            columns={columns}
            dataSource={subjectSummaryData}
            pagination={false}
            scroll={{ x: "100%" }}
            bordered
            style={{ marginTop: 10, width: "100%", pageBreakInside: "avoid" }}
          />
        </div>
      </div>
    </div>
  );
};

export default OverallSummary;
